$(document).ready(function() {
  $('.article__filters_container_action_btns button').on('click', function () {
    var value = $(this).attr("data-blog-type");
    $('.article__filters_container_action_btns button').filter(function () {
      if ($(this).text().toLowerCase().indexOf(value) > -1) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });

    if (value !== 'all') {
      $(".articles-list__item").filter(function () {
        $(this).toggle($(this).attr('class').split(" ")[1].toLowerCase().indexOf(value) > -1)
      });
    } else {
      $(".articles-list__item").filter(function () {
        $(this).show();
      });
    }
  });
  $('.article__filters_container .input__icon').on('click', function () {
    var value = $('.article__filters_container .article-filters-search__input').val();
    if (value) {
      window.location.assign("https://" + window.location.host + "/search?q=" + value + "*&type=article");
    }
  });
});